import { DEFAULT_DECIMAL_PLACES } from './config';
import { createDecimal } from './utils';
import Decimal from 'decimal.js';

/**
 * 四舍五入
 */
export const round = (
  value: number | string,
  decimalPlaces: number = DEFAULT_DECIMAL_PLACES
): number => {
  return createDecimal(value).toDecimalPlaces(decimalPlaces).toNumber();
};

/**
 * 向上取整
 */
export const ceil = (
  value: number | string,
  decimalPlaces: number = DEFAULT_DECIMAL_PLACES
): number => {
  return createDecimal(value).toDecimalPlaces(decimalPlaces, Decimal.ROUND_UP).toNumber();
};

/**
 * 向下取整
 */
export const floor = (
  value: number | string,
  decimalPlaces: number = DEFAULT_DECIMAL_PLACES
): number => {
  return createDecimal(value).toDecimalPlaces(decimalPlaces, Decimal.ROUND_DOWN).toNumber();
};
